import { render, staticRenderFns } from "./button_color.vue?vue&type=template&id=790f21f8&scoped=true&lang=pug&"
import script from "./button_color.vue?vue&type=script&lang=js&"
export * from "./button_color.vue?vue&type=script&lang=js&"
import style0 from "./button_color.vue?vue&type=style&index=0&id=790f21f8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790f21f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('790f21f8', component.options)
    } else {
      api.reload('790f21f8', component.options)
    }
    module.hot.accept("./button_color.vue?vue&type=template&id=790f21f8&scoped=true&lang=pug&", function () {
      api.rerender('790f21f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form_element/button_color.vue"
export default component.exports